import UAParser from 'ua-parser-js'

const parser = new UAParser()
const minimumVersions = {
    Firefox: 28,
    Chrome: 29,
    Chromium: 29,
    Safari: 9,
    Edge: 12,
}

export const getBrowser = () => parser.getBrowser()

export const isEdge = () => {
    const browser = getBrowser()
    return !!(browser && browser.name && browser.name === 'Edge')
}

export const isUnsupportedBrowser = () => {
    const { name, version } = getBrowser()
    return !!(minimumVersions[name] && version < minimumVersions[name])
}

export default getBrowser
